
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M17 17.333h2-2zM17 20.667h2-2zM17 16h2-2zM11.02 16h4.667-4.666zM11.02 17.333h4.667-4.666zM11.02 14.61h8-8zM11 10.667h3.333H11zM12.667 9v3.333V9z","stroke":"#4B62C1"}}),_c('path',{attrs:{"d":"M21 9.97h-3.337V7.03","stroke":"#4B62C1"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M9 7v16h12V9.969l-3.337-2.94L9 7z","stroke":"#4B62C1"}})])
          )
        }
      }
    